import { ClienteVendaMetadados } from '../../../../../../../types/cliente-venda';
import { CollapsibleSection } from '../../produtos/sections/collapsible-section';
import { Row } from './styles';

interface Props {
  data: ClienteVendaMetadados;
}

export const MetadadosSection = ({ data }: Props) => {
  const hasAny =
    data.src ||
    data.sck ||
    data.utmSource ||
    data.utmCampaign ||
    data.utmMedium ||
    data.utmContent ||
    data.utmTerm ||
    (data.urlParams && Object.keys(data.urlParams).length > 0);

  return (
    <CollapsibleSection
      title="Metadados e tracking"
      testId="venda-section-metadados"
    >
      {!hasAny ? (
        <Row>
          <span>—</span>
          <span>Sem metadados de tracking nesta venda</span>
        </Row>
      ) : (
        <>
          {data.utmSource && (
            <Row>
              <span>UTM source</span>
              <span>{data.utmSource}</span>
            </Row>
          )}
          {data.utmCampaign && (
            <Row>
              <span>UTM campaign</span>
              <span>{data.utmCampaign}</span>
            </Row>
          )}
          {data.utmMedium && (
            <Row>
              <span>UTM medium</span>
              <span>{data.utmMedium}</span>
            </Row>
          )}
          {data.utmContent && (
            <Row>
              <span>UTM content</span>
              <span>{data.utmContent}</span>
            </Row>
          )}
          {data.utmTerm && (
            <Row>
              <span>UTM term</span>
              <span>{data.utmTerm}</span>
            </Row>
          )}
          {data.src && (
            <Row>
              <span>src</span>
              <span>{data.src}</span>
            </Row>
          )}
          {data.sck && (
            <Row>
              <span>sck</span>
              <span>{data.sck}</span>
            </Row>
          )}
          {data.urlParams &&
            Object.entries(data.urlParams).map(([k, v]) => (
              <Row key={k}>
                <span>url[{k}]</span>
                <span>{v}</span>
              </Row>
            ))}
        </>
      )}
    </CollapsibleSection>
  );
};
